var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPinIconSvg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4679_130475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2112 18.8692L12.6306 25.4353L6.04994 18.8692C4.74844 17.5706 3.86211 15.916 3.50303 14.1148C3.14396 12.3136 3.32826 10.4465 4.03264 8.74978C4.73701 7.05304 5.92983 5.60282 7.46024 4.5825C8.99066 3.56217 10.7899 3.01758 12.6306 3.01758C14.4712 3.01758 16.2704 3.56217 17.8009 4.5825C19.3313 5.60282 20.5241 7.05304 21.2285 8.74978C21.9328 10.4465 22.1171 12.3136 21.7581 14.1148C21.399 15.916 20.5127 17.5706 19.2112 18.8692ZM12.6306 14.3667C13.179 14.3667 13.7051 14.1493 14.0929 13.7623C14.4807 13.3753 14.6986 12.8505 14.6986 12.3032C14.6986 11.7559 14.4807 11.2311 14.0929 10.8441C13.7051 10.4571 13.179 10.2397 12.6306 10.2397C12.0821 10.2397 11.556 10.4571 11.1682 10.8441C10.7804 11.2311 10.5625 11.7559 10.5625 12.3032C10.5625 12.8505 10.7804 13.3753 11.1682 13.7623C11.556 14.1493 12.0821 14.3667 12.6306 14.3667Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4679_130475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8169,
    height: 24.7619,
    fill: "white",
    transform: "translate(0.222656 0.953125)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPinIconSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pinIconSVG.2961f4fe.svg";
export { ForwardRef as ReactComponent };